<template>
  <f7-page name="pro" class="navbar-through toolbar-fixed">
    <f7-navbar>
      <f7-nav-left>
        <f7-button @click="goBack()" v-show="showBackButton"><f7-icon f7="arrow_left"></f7-icon></f7-button>
        <div class="navbar-left-space" v-show="!showBackButton"></div>
      </f7-nav-left>
      <f7-nav-title class="navbar-center-title">{{ pro.name }}</f7-nav-title>
      <f7-nav-right>
        <f7-button @click="goHome()"><f7-icon f7="home_fill"></f7-icon></f7-button>
      </f7-nav-right>
    </f7-navbar>

    <f7-swiper :params="questionGroupSliderOptions"
               ref="questionGroupSlider"
               v-show="!resultsShown"
               style="height:100%"
               :pagination="false"
               :scrollbar="this.pro.questionGroups.length > 1">
      <div slot="before-wrapper" class="question-group-swiper-scrollbar swiper-scrollbar"></div>

      <f7-swiper-slide v-for="(questionGroup, qgIdx) in this.pro.questionGroups" :key="qgIdx">
        <div class="box">
          <div class="row header">
            <f7-block>
              <f7-block-header><span v-html="questionGroup.name"></span></f7-block-header>
              <span v-html="questionGroup.description"></span>
            </f7-block>
          </div>
          <div class="row content">
            <f7-swiper :pagination="false"
                       :params="questionSliderOptions"
                       :scrollbar="true"
                       :navigation="false"
                       :ref="'questionSlider' + qgIdx"
                       style="display: flex">
              <f7-swiper-slide v-for="question in questionGroup.questions" :key="question.id">
                <question :question="question"
                          :ref="'question'"
                          @answerSelected="answerId => { acceptAnswer(question, answerId, 'questionSlider' + qgIdx) }"></question>
              </f7-swiper-slide>
            </f7-swiper>
          </div>
        </div>
      </f7-swiper-slide>
    </f7-swiper>

    <results :answeredQuestions="pro"
             :results="results"
             :showErrors="showErrors"
             v-show="resultsShown"
             @back="toggleResults()"
             ref="results"></results>

    <f7-toolbar bottom-md v-show="!resultsShown && finished">
      <f7-link></f7-link>
      <f7-link @click.prevent="toggleResults()">REZULTATI&nbsp;&nbsp;<f7-icon f7="arrow_right_fill"></f7-icon></f7-link>
    </f7-toolbar>
  </f7-page>
</template>

<script>
import {getPro} from '../assets/pros/pros'
import Question from './Question'
import Results from './Results'

export default {
  name: 'Pro',
  components: {
    'question': Question,
    'results': Results
  },
  data () {
    return {
      resultsShown: false,
      finished: false,
      afterSelectDelay: 300,
      showBackButton: false,
      showErrors: false,
      questionSliderOptions: {
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 50,
        autoHeight: true,
        preventInteractionOnTransition: true,
        threshold: 30
      },
      questionGroupSliderOptions: {
        direction: 'vertical',
        speed: 700,
        slidesPerView: 1,
        preventInteractionOnTransition: true,
        shortSwipes: false,
        threshold: 30,
        scrollbar: {
          el: '.question-group-swiper-scrollbar'
        }
      },
      pro: getPro(this.$f7route.params.id),
      results: {}
    }
  },
  methods: {
    getQuestionsErrors: function () {
      let errors = []
      this.pro.questionGroups.forEach((qg, qgIdx) => {
        qg.questions.forEach((q, qIdx) => {
          if (q.selectedAnswer === null) {
            errors.push({
              'questionGroupIndex': qgIdx,
              'questionIndex': qIdx
            })
          }
        })
      })
      return errors
    },
    getAnswers: function () {
      let answers = {}
      this.pro.questionGroups.forEach(questionGroup => {
        questionGroup.questions.forEach(question => {
          let selectedAnswer = question.getSelectedAnswer()
          if (selectedAnswer !== null) {
            answers[question.id] = selectedAnswer.value
          }
        })
      })
      return answers
    },
    updateQuestions: function () {
      this.$refs.question.forEach(q => {
        q.$forceUpdate()
      })
    },
    toggleResults: function () {
      if (!this.resultsShown) {
        const questionErrors = this.getQuestionsErrors()
        if (questionErrors.length > 0) {
          const error = questionErrors[0]
          this.pro.questionGroups[error.questionGroupIndex].questions[error.questionIndex].hasErrors = true
          this.updateQuestions()
          this.$refs.questionGroupSlider.swiper.slideTo(error.questionGroupIndex)
          this.getCurrentlyActiveQuestionSlider().slideTo(error.questionIndex)
          return
        }
      }
      this.resultsShown = !this.resultsShown
      if (this.resultsShown) {
        this.computeResults()
        this.$refs.results.$forceUpdate()
      } else {
        this.$nextTick(function () {
          this.updateQuestions()
          this.getCurrentlyActiveQuestionSlider().update()
          this.getCurrentlyActiveQuestionSlider().scrollbar.updateSize()
        })
      }
    },
    acceptAnswer: function (question, answerId, sliderRef) {
      question.selectedAnswer = answerId
      question.hasErrors = false
      if (this.finished) {
        return
      }
      window.setTimeout(() => {
        const slider = this.$refs[sliderRef][0].swiper
        const questionGroupSlider = this.$refs.questionGroupSlider.swiper
        if (!slider.isEnd) {
          slider.slideNext()
        } else if (!questionGroupSlider.isEnd) {
          questionGroupSlider.slideNext()
        } else {
          this.finished = true
        }
        this.showBackButton = !this.areWeAtStart()
      }, this.afterSelectDelay)
    },
    goBack: function () {
      const questionGroupSlider = this.$refs.questionGroupSlider.swiper
      const questionSlider = this.getCurrentlyActiveQuestionSlider()
      if (this.resultsShown) {
        this.toggleResults()
      } else if (!questionSlider.isBeginning) {
        questionSlider.slidePrev()
      } else if (!questionGroupSlider.isBeginning) {
        questionGroupSlider.slidePrev()
      }
      this.showBackButton = !this.areWeAtStart()
    },
    getCurrentlyActiveQuestionSlider: function () {
      const questionGroupSlider = this.$refs.questionGroupSlider.swiper
      return this.$refs[`questionSlider${questionGroupSlider.realIndex}`][0].swiper
    },
    areWeAtStart: function () {
      return this.getCurrentlyActiveQuestionSlider().isBeginning && this.$refs.questionGroupSlider.swiper.isBeginning
    },
    goHome: function () {
      this.$f7.dialog.confirm('S tem boste izgubili vse do sedaj izpolnjene podatke.', 'Ali ste prepricani?', () => {
        this.$f7router.navigate('/')
      })
    },
    computeResults: function () {
      this.results = this.pro.results.map(result => {
        let evalResults = function () {
          // eslint-disable-next-line no-eval
          return eval(result.formula)
        }
        result.value = evalResults.call(this.getAnswers())
        return result
      })
    }
  },
  on: {
    pageInit (event, pageData) {
      this.datePicker = this.$f7.calendar.create({
        inputEl: '#results-test-date',
        dateFormat: 'dd.mm.yyyy',
        closeOnSelect: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  div[data-name="pro"] /deep/ {

    @media print {
      .navbar {
        background: none;
        box-shadow: none;
        height: 50px;

        .title {
          text-align: center;
          color: #555;
          width: 100%;
        }

        .right {
          display: none;
        }

        .left {
          display: none;
        }
      }

      .navbar:after {
        background: none;
      }
    }

    .box {
      display: flex;
      flex-flow: column;
      height: 100%;
    }

    .box .row.header {
      flex: 0 1 auto;
      /* The above is shorthand for:
    flex-grow: 0,
    flex-shrink: 1,
    flex-basis: auto
    */
    }

    .box .row.content {
      flex: 1 1 auto;
      align-items: stretch;
    }

    .box .row.footer {
      flex: 0 1 5px;
    }

    .navbar-left-space {
      display: inline-block;
      width: 48px;
      padding: 0 8px;
    }

    .navbar-center-title {
      display: flex;
      flex-grow: 100;
      justify-content: center;
    }

    .block {
      margin: 15px 0;
    }

    .list {
      margin-top: 15px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Pro.vue